import * as React from "react";
import { styled } from "styled-components";

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 1.3rem;
`;

const CheckboxLabel = styled.div``;

const CheckboxText = styled.label`
  margin: 0 0 0 0.5rem;
  display: inline-block;
  cursor: pointer;
  touch-action: manipulation;
  transition: all 200ms ease-in-out;

  & * {
    cursor: pointer;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0.1rem;
    left: 0;
    width: 1.3rem;
    height: 1.3rem;
    border-radius: 10%;
    background: transparent;
    transition: all 200ms ease-in-out;
    border: 1px solid ${(props) => props.theme.colours.grey[400]};
    box-shadow: 0 0 0 0 ${(props) => props.theme.colours.focus};
  }

  &:after {
    content: "";
    position: absolute;
    top: 0.23rem;
    left: 0.15rem;
    width: 1rem;
    height: 1rem;
    background-color: white;
    clip-path: polygon(15.3% 43.5%, 45% 74.8%, 85.5% 13.3%, 94% 19%, 45.8% 91.3%, 7.3% 51%);
    border-radius: 10%;
    transition: all 200ms ease-in-out;
    opacity: 0;
  }
`;

export const CheckboxEl = styled.input.attrs({ type: "checkbox" })<{ error?: unknown }>`
  cursor: pointer;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 1.3rem;
  height: 1.3rem;
  margin: 0;
  opacity: 0;
  transition: all 200ms ease-in-out;

  & + ${CheckboxText} {
    &:before {
      border-color: ${(props) => (!props.error ? props.theme.colours.grey[400] : props.theme.colours.error)};
      background-color: ${(props) => (!props.error ? "transparent" : props.theme.colours.red[50])};
    }
  }

  &:checked + ${CheckboxText} {
    &:after {
      opacity: 1;
    }
    &:before {
      border-color: ${(props) => props.theme.colours.grey[400]};
      background-color: ${(props) => props.theme.colours.primary};
    }
  }

  &:focus + ${CheckboxText} {
    &:before {
      box-shadow: 0 0 0 3px ${(props) => props.theme.colours.focus};
    }
  }

  &:hover + ${CheckboxText} {
    &:before {
      border-color: ${(props) => props.theme.colours.grey[500]};
    }
  }
`;

export const Checkbox: React.FC<React.ComponentProps<typeof CheckboxEl>> = ({ children, ...otherProps }) => {
  const { id } = otherProps;

  return (
    <CheckboxContainer>
      <CheckboxEl id={id} {...otherProps} />
      <CheckboxText htmlFor={id}>
        <CheckboxLabel>{children}</CheckboxLabel>
      </CheckboxText>
    </CheckboxContainer>
  );
};
